import { render } from "./UpdatePhoneView.vue?vue&type=template&id=c2e32df2&scoped=true"
import script from "./UpdatePhoneView.vue?vue&type=script&lang=js"
export * from "./UpdatePhoneView.vue?vue&type=script&lang=js"

import "./UpdatePhoneView.vue?vue&type=style&index=0&id=c2e32df2&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e32df2"]])

export default __exports__